<template>
  <div class="Prices">
      <h2>Internal Error</h2>
      <p>Whoops, something went wrong</p>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
